import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useAction } from 'hooks';
import { DayRangePicker, CalendarBtn, DateInput } from 'components/DatePickers';
import PopUp from 'components/PopUp';
import App from 'modules/App';
import { RANGE_PICKER_POPUP } from '../../../constants';
const ResultsRange = ({ startDate, endDate, minDate, maxDate, // newResultsStartDate,
isInProgress = false, onChange, onClose })=>{
    const closeDropdown = useAction(App.actions.closeDropdown);
    const onRangeChange = (range)=>{
        onChange(range.from, range.to);
        if (range.from && range.to) {
            closeDropdown();
        }
    };
    const onStartChange = (newStartDate)=>{
        onChange(newStartDate, endDate);
    };
    const onEndChange = (newEndDate)=>{
        onChange(startDate, newEndDate);
    };
    const onClosePicker = ()=>{
        onClose();
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "DateRangePickerInput DateRangePickerInput__withBorder",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "DateRangePickerInput",
                children: [
                    /*#__PURE__*/ _jsx(DateInput, {
                        id: "startDate",
                        popUpName: RANGE_PICKER_POPUP,
                        momentDate: startDate,
                        disabled: {
                            before: startDate,
                            after: endDate || maxDate
                        },
                        isInProgress: isInProgress,
                        onChange: onStartChange
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "DateRangePickerInput_arrow",
                        "aria-hidden": "true",
                        role: "presentation",
                        children: /*#__PURE__*/ _jsx("span", {
                            children: "-"
                        })
                    }),
                    /*#__PURE__*/ _jsx(DateInput, {
                        id: "endDate",
                        popUpName: RANGE_PICKER_POPUP,
                        momentDate: endDate,
                        disabled: {
                            before: startDate || minDate,
                            after: maxDate
                        },
                        isInProgress: isInProgress,
                        onChange: onEndChange
                    }),
                    /*#__PURE__*/ _jsx(PopUp, {
                        id: RANGE_PICKER_POPUP,
                        backgroundColor: "standard",
                        noPadding: true,
                        onClose: onClosePicker,
                        children: /*#__PURE__*/ _jsx(DayRangePicker, {
                            range: {
                                from: startDate,
                                to: endDate
                            },
                            disabled: {
                                before: minDate,
                                after: maxDate
                            },
                            isLocalTime: true,
                            onChange: onRangeChange
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(CalendarBtn, {
                popUpName: RANGE_PICKER_POPUP,
                isDisabled: isInProgress
            })
        ]
    });
};
export default ResultsRange;
